<div class="modal-body modal-scss">
  <div class="row mb-3">
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-center">
        <i-button styleClass="blue me-3" [text]="'openAll' | translate" (click)="expandAll()"></i-button>
        <i-button styleClass="blue" [text]="'closeAll' | translate" (click)="collapseAll()"></i-button>
      </div>
    </div>
    @if (!loading) {
      <div class="maxHeight60vh">
        <p-tree
          [value]="classements"
          appendTo="body"
          selectionMode="single"
          [(selection)]="selectedNode"
          (onNodeSelect)="onClassementSelect($event)"
          [emptyMessage]="'noResultFound' | translate"
          styleClass="w-100 pTreeServicesModal"
          [filter]="true">
        </p-tree>
      </div>
    }

    @if (loading) {
      <div class="loader_div">
        <i-loader [size]="100" [text]="'loading' | translate"></i-loader>
      </div>
    }
  </div>
  <i-button
    [text]="'validate' | translate"
    styleClass="bottomButton green"
    tooltipPosition="bottom"
    tooltipZIndex="99999999"
    [pTooltip]="'classification.validateTheClassification' | translate"
    (click)="onSubmit()">
  </i-button>
</div>
